import fetchAPI from '../fetchUtils';

const rootAPI = {
  user: async () => fetchAPI.getWithAuth('/get-user'),
};

export default rootAPI;
